module.exports = __webpack_public_path__ + "img/logoT2C.db927ec2.png";